var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeBarGraph = function SvgThreeBarGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CECCCE",
    d: "M.266 25.56h12.243v12.333H.266z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5B3552",
    fillRule: "evenodd",
    d: "M24.751 13.228H12.508v24.665H24.75V13.228",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E5B",
    fillRule: "evenodd",
    d: "M36.994.894H24.75v12.333h12.243zM24.75 13.228h12.243v24.665H24.75V13.228",
    clipRule: "evenodd"
  })));
};
export { SvgThreeBarGraph as ReactComponent };
export default __webpack_public_path__ + "images/three-bar-graph.svg";